import constants from "$utils/constants";

export default {
  api_url: constants.API.ENDPOINT,
  shipping_api_url: constants.SHIPPING_API.ENDPOINT,
  sync_url: constants.SYNC_API.ENDPOINT,
  order_url: constants.ORDER_API.ENDPOINT,
};
